
import SpeedkitPicture from '#speedkit/components/SpeedkitPicture'

export default {
  name: 'Testimonial',
  components: {
    SpeedkitPicture,
  },
  props: {
    image: {
      type: Object,
      require: false,
    },
    name: {
      type: String,
      require: true,
    },
    title: {
      type: String,
      require: true,
    },
    quote: {
      type: String,
      require: true,
    },
  },
}
